// extracted by mini-css-extract-plugin
export default {"table":"styles_table__aWYT-","dragging":"styles_dragging__0y7XP","headingRow":"styles_heading-row__DxMVZ","draggingOver":"styles_dragging-over__V91aT"};